import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { ConfigService } from "../config/config.service";

@Injectable({
  providedIn: "root",
})
export class LeadsService {
  constructor(
    private http: HttpClient,
    private configService: ConfigService,
  ) {}

  sendReferEmail(customerId: number, emails: string[]): Observable<any> {
    return this.http.post<any>(
      `${this.configService.environment.leads.url}/api/lead/${customerId}/refer-via-email`,
      { emails }
    );
  }
}
